











import {ChartDataTemplate, WConfTpl, WidgetDefinition, WParamTpl} from '@/components/widgets/WidgetFather'
import {bus} from '@/main'
import {defineComponent, reactive} from "@vue/composition-api"
import FusionChartWidget from "@/components/widgets/FusionChartWidget.vue"
import {extractParams, getTitle} from "@/components/widgets/hd/hdCommon"
import {executeQuery} from "@/data/repos/query"

export function config(): WidgetDefinition {
    return {
      ...WConfTpl.KeyValue(),
      widget: "HDInhouseReactiveJobsAllocatedForMonthToDate",
      title: "In-house reactive jobs allocated for month to date",
      _description: "",
      params: {
        hdJobCategory: {...WParamTpl.hdJobCategory(), _order: 1},
      },
    }
  }

  async function dataFetcher(params: any) {
    const p = extractParams(params)
    return {
      data: await executeQuery(
        'FMS_DB',
        'inhouseReactiveJobsAllocatedForMonthToDate',
        {category: p.jobCategory, year: p.year, month: p.month}),
    }
  }

  function getChartDataConfig() {
    return reactive({
        ...ChartDataTemplate(),
        showZeroPies: "1",
        showPercentValues: "0",
        showPercentInTooltip: "1",
      },
    )
  }

  async function configChangeCallback(config: any, chartConfig: any, chartDataConfig: any) {
    config && (chartDataConfig.subCaption = getTitle(config.params))
  }

  export default defineComponent({
    props: {config: {type: Object, required: true}},
    components: {FusionChartWidget},
    setup(props, context) {
      context.emit("config-update", config())

      function dataplotClickCallback(label: any, val: any) {
        if (label === undefined) {
          return
        }
        const status = label.toLowerCase() === "completed" ? 0 : 1
        console.log("label", label)
        const componentArgs = {...extractParams(props.config.params), status}
        bus.$emit('chartPopup', {
          title: config().title + ": " + getTitle(props.config.params),
          component: () => import('@/components/drilldowns/InhouseReactiveJobsAllocatedForMonthToDateGrid.vue'),
          componentArgs,
        })
      }

      return {dataFetcher, getChartDataConfig, configChangeCallback, dataplotClickCallback}
    },
  })
